import { Link } from 'react-router-dom';
import './homepage.css';

const Homepage: React.FC = (
) => (
    <div className='homepage'>
        <div>Fan Pages</div>
        <div>Game Directory</div>
        <div className='game-directory'>
            <nav>
                <Link to="/heiscoming"><img src="/resources/he_is_coming_banner.jpg" alt="He Is Coming" /></Link>
            </nav>
        </div>
    </div>
);
export default Homepage;